module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble",
      "lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVII",
      "role": "doc-pagebreak",
      "title": "XVII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "pre3",
      "src": "images/pre3.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_vm._v("I THANK GOD ")]), _vm._v("for many things throughout this process. I’m grateful first for Mike Allen, who encouraged me to do my doctoral work at Knox Seminary and not somewhere else, and I’m doubly grateful that as I began, unbeknownst to me, Knox was architecting a short-lived but perfect-for-me track called “The Theology and Worship of the English Reformation.” It’s not an overstatement to say that this coursework has changed the trajectory of my life.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’m grateful to David McNutt and the team of editors who helped make this book significantly better than it started. In particular, two scholars under David’s supervision shed incredible light on many weaknesses of argumentation and even some significant errors. This process elevated the quality of scholarship, and I am humbly appreciative. I also give thanks to the advisory board of the Dynamics of Christian Worship series who had the generosity and vision to see this as a valuable contribution to this great lineup of books and authors.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book wouldn’t have seen the light of day if it were not for significant mentors, friends, and dialogue partners. Ashley Null’s teaching, conversations, and correspondence have greatly shaped and sharpened this work. Dialogues in the in-between moments inside and outside the office with Gil Kracke have impacted my thinking, and I’m thankful that Gil graciously took the time to read an early version of my manuscript and provide critical feedback. Andrew Pearson, whether he knew it or not, was always providing fresh angles, new insights, and untapped scholarship in our many dialogues. Sheri Herum found nonexistent gaps in the rearing of five small children to read and edit my manuscript, providing not only some forehead-wiping saves, but also some great questions and comments that sharpened my argumentation and line of thinking. Lisa Yeager graciously lent her expertise "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVIII",
      "role": "doc-pagebreak",
      "title": "XVIII"
    }
  }, [_vm._v("in Latin to ensure that my quotations and translations were accurate. Brenda and Leon Hicks, my parents, led me to Christ and his gospel, and gave me a writer’s genetics. Finally, I thank God for my friend, mentor, and doctoral supervisor, Jonathan Linebaugh. This book is the fruit of nearly a decade of meaningful conversation, shared life experiences, supportive friendship, and international gallivanting.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Throughout the process, I had two families who supported my work more than any other. First, my spiritual family at the Cathedral Church of the Advent cheered me on, provided financial assistance to complete this work, and gave me real-time feedback as I repeatedly taught on these concepts and attempted to apply them in our weekly worship in downtown Birmingham. My time at the Advent was proof that this kind of scholarship isn’t ivory-tower work but meaningful on the ground, for real life and real concerns. Second, and most importantly, my immediate family—my tribe—has supported me by suffering through long stretches of my typing away with big piles of books around me, buried and inattentive. Abby has shouldered extra work, and there were a few “fatherless” times in the fall of 2019 for Joel, Jesse, Brody, and Bronwyn, which they all accepted without complaint. I couldn’t have done this without their support and grace.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 75
// module chunks = 0